/*# sourceMappingURL=organisations-overview.component-VIKNW54O.css.map */
